import connect from "react-redux/es/connect/connect";
import {API_HOST, API_ROOT, http} from "../../../../util/http";
import {
    addProduct,
    checkoutInventory,
    deleteProduct, emptyInventory,
    updateProduct, updateProductFormats,
    updateProductLocationAmount
} from "../../../../state/modules/inventory";
import {fetchActiveRegister} from "../../../../state/modules/register";

import React from "react";
import {validateForm} from "../../../../util/validation";
import ui from "../../../../util/ui";

import ModuleView from "../../module-view/index";
import List from "../../list";
import ReleaseListItem from "../release-list-item";
import Window from "../../window";
import Search from "../../search";
import Pagination from "../../pagination";
import ButtonGroup from "../../button-group";
import Button from "../../../atoms/button";
import Popup from "../../popup";
import TextInput from "../../../atoms/text-input";
import Form from "../../form";
import LoadingOverlay from "../../loading-overlay";
import {handleTokenErrors} from "../../../../state/modules/errors";
import ReleaseStockEdit from "../release-stock-edit";
import TagInput from "../../../atoms/tag-input";
import PickListCreate from "../pick-list-create";
import PickLists from "../pick-lists";
import PickItemsList from "../pick-items-list";
import InventoryUpdateStock from "../inventory-update-stock";
import LinkButton from "../../../atoms/link-button";
import Dropout from "../../dropout";
import Label from "../../../atoms/label";
import PrintNameplate from "../print-nameplate";
import Grid from "../../grid";
import LocationFilter from "../../location-filter";

class InventoryModule extends ModuleView {

    locations = [
        {
            key: 'stock_2',
            label: 'Offline stock'
        },
        {
            key: 'stock',
            label: 'Online stock'
        }
    ];

    constructor(props) {
        super(props);
        
        this.views = {
            index: (
                <Window
                    title="Inventory"
                    header={
                        <ButtonGroup>
                            <Button onClick={e => this.updateView('updateStock')} text={'Update stock'}/>
                            <Button onClick={e => this.updateView('picker')} text={'Picker'}/>
                            <Search listId="releases"/>
                            <Dropout icon={'moreVertical'} modifiers={'align-right'}>
                                <LinkButton onClick={e => this.openPopup('printNameplate')}>
                                    <span>Print Nameplate</span>
                                </LinkButton>
                            </Dropout>
                        </ButtonGroup>
                    }
                >
                    <Grid rows="auto 1fr">
                        <Window modifiers={['depth', 'padded']}>
                            <LocationFilter listId={'releases'} filterKey={'filter_location'} setDefaultFromRegister={true} />
                        </Window>
                        <Window modifiers="depth" footer={<Pagination listId="releases"/>}>
                            <List
                                id={'releases'}
                                model={'releases'}
                                selectable={false}
                            >
                                <ReleaseListItem
                                    onManageStock={(release) => this.openPopup('releaseStockUpdate', release, release.id)}
                                />
                            </List>
                        </Window>
                    </Grid>
                </Window>
            ),
            updateStock: (
                <Window
                    title="Update Stock"
                    header={
                        <ButtonGroup>
                            <Button
                                text="Search by Discogs id"
                                onClick={e => this.openPopup('discogsIdSearch')}
                            />
                        </ButtonGroup>
                    }
                    footer={
                        <ButtonGroup>
                            <Button
                                text="Cancel"
                                modifiers={'alt'}
                                onClick={e => this.updateView('index')}
                            />
                            <Button
                                text="Add to stock"
                                onClick={e => {
                                    this.props.checkoutInventory();
                                    this.updateView('index');
                                }}
                            />
                        </ButtonGroup>
                    }
                >
                    <LoadingOverlay isLoading={this.state.isLoading} />
                    <InventoryUpdateStock
                        activeLocation={this.state.activeLocation}
                        isScanning={this.state.isScanning}
                        toggleLoading={() => this.toggleLoading()}
                        toggleScanning={() => this.toggleScanning()}
                        openPopup={(...popup) => this.openPopup(...popup)}
                    />
                </Window>
            ),
            picker: (
                <Window
                    title="Picking Lists"
                    header={
                        <ButtonGroup>
                            <Button onClick={e => this.openPopup('createPickList')} text={'Create list'} />
                            <Button onClick={e => this.updateView('index')} text={'Back to Inventory'} modifiers="alt" />
                        </ButtonGroup>
                    }
                >
                    <PickLists onViewList={list => this.openPopup('viewPickList', list)} />
                </Window>
            ),
        };

        this.popups = {
            discogsIdSearch: () => {

                return (
                    <Popup title="Search by discogs id">
                        <Form
                            validate={(form, data) => validateForm(form, data, {discogsId: ['required']})}
                            submitButtonText={'Search'}
                            onSubmit={data => {

                                let discogsId = data.discogsId;
                                let release = this.findValue(this.props.products, 'discogs_id', discogsId);

                                if (release) {

                                    this.props.addProduct(release, this.state.activeLocation);
                                    this.closePopup('discogsIdSearch');
                                    return;
                                }

                                this.toggleLoading();

                                http.get(API_HOST + API_ROOT + 'releases/findbydiscogsid', true, {discogsId: discogsId}).then(response => {

                                    let discogsRelease = response.result;
                                    this.props.addProduct(discogsRelease, this.state.activeLocation);
                                    this.toggleLoading();
                                    this.closePopup('discogsIdSearch');

                                }).catch(error => {

                                    if (error.message === 'release_not_found') {

                                        http.get(API_HOST + API_ROOT + 'discogs/id/' + discogsId, true).then(response => {

                                            let discogsRelease = response.result;
                                            this.toggleLoading();
                                            this.closePopup('discogsIdSearch', '', () => {
                                                this.openPopup('discogsReleaseCreate', discogsRelease, discogsRelease.barcode);
                                            });

                                        }).catch(error => {

                                            this.toggleLoading();

                                            if (error.message === 'release_not_found') {
                                                ui.notify('Discogs release not found', 'error');
                                            }
                                        });

                                    }
                                })
                                    .catch(error => handleTokenErrors(error));
                            }}
                        >
                            <TextInput name={'discogsId'} label={'Discogs id'} showRequiredIndicator={true}
                                       focus={true}/>
                        </Form>
                    </Popup>
                );
            },
            discogsReleaseCreate: (discogsRelease) => {

                return (
                    <Popup title={'Add: ' + discogsRelease.title}>
                        <Form
                            validate={(form, data) =>
                                validateForm(form, data, {
                                    price: ['required', 'number'],
                                })
                            }
                            submitButtonText={'Create'}
                            onSubmit={data => {
                                discogsRelease.price = data.price;
                                discogsRelease[this.state.activeLocation] = 0;
                                discogsRelease.formats = data.formats;

                                this.props.addProduct(discogsRelease, this.state.activeLocation);
                                this.props.updateProductFormats(discogsRelease, data.formats);

                                this.closePopup('discogsReleaseCreate', discogsRelease.barcode);
                                this.toggleScanning();
                            }}
                        >
                            <TextInput name="price" label="Price" showRequiredIndicator={true} focus={true}/>
                            <TagInput
                                name="formats"
                                label="Formats"
                                autocomplete={true}
                                suggestions={this.state.formats}
                            />
                        </Form>
                    </Popup>
                );
            },
            productStockUpdate: (product) => {
                // check if product.formats exists and is a string or an array
                let productFormats = product.formats;
                
                if (!productFormats) {
                    productFormats = [];
                } else if (typeof productFormats === 'string') {
                    productFormats = JSON.parse(productFormats);
                }
                
                let formats = this.state.formats.map(format => {
                    return {
                        value: format.value,
                        label: format.label,
                        selected: productFormats ? productFormats.filter(selectedFormat => {
                            return parseInt(selectedFormat.id) === parseInt(format.value);
                        }).length > 0 : false
                    };
                });

                return (
                    <Popup title={'Edit product'}>
                        <Form
                            validate={(form, data) => {
                                validateForm(form, data, {
                                    price: ['required', 'number'],
                                })
                            }}
                            submitButtonText={'Update'}
                            onSubmit={data => {
                                this.props.updateProduct({...product, ...{price: data.price}});
                                this.props.updateProductFormats(product, data.formats);
                                this.closePopup('productStockUpdate');
                            }}
                        >
                            <TextInput name="price" label="Price" showRequiredIndicator={true} focus={true}
                                       default={product.price}/>
                            <TagInput
                                name="formats"
                                label="Formats"
                                autocomplete={true}
                                suggestions={formats}
                            />
                        </Form>
                    </Popup>
                )
            },
            releaseStockUpdate: (release) => {
                return (
                    <Popup title={'Edit release'} fullscreen={true}>
                        <ReleaseStockEdit
                            release={release}
                            onSave={release => {
                                this.updateView();
                                this.closePopup('releaseStockUpdate', release.id);
                                this.updateView('index');
                            }}
                        />
                    </Popup>
                )
            },
            createPickList: () => {
                return (
                    <Popup title={'Create pick list'}>
                        <PickListCreate
                            onSave={list => {
                                this.updateView();
                                this.updateView('picker');
                                
                                this.closePopup('createPickList');
                                this.openPopup('viewPickList', list);
                                
                                ui.notify('Pick list created');
                            }}
                        />
                    </Popup>
                )
            },
            viewPickList: (list) => {
                return (
                    <Popup
                        title={list.location.name + ': Pick list'}
                        fullscreen={true}
                        padded={false}
                        header={list.status === 'pending' && (
                            <ButtonGroup>
                                <Button
                                    onClick={e => {
                                        http
                                            .post(API_HOST + API_ROOT + 'pick_lists/' + list.id + '/complete', {}, true)
                                            .then(response => {
                                                this.updateView();
                                                this.updateView('picker');
                                                
                                                this.closePopup('viewPickList');
                                                
                                                ui.notify('Pick list completed');
                                            })
                                    }}
                                    text={'Complete list'} />
                            </ButtonGroup>
                                )}
                    >
                        <PickItemsList list={list} />
                    </Popup>
                )
            },
            printNameplate: () => {
                return (
                    <Popup title={'Print Nameplate'}>
                        <PrintNameplate />
                    </Popup>
                )
            }
        };

        this.state = {
            view: this.views.index,
            activeLocation: this.locations[0].key,
            isScanning: true,
            isLoading: false,
            formats: [],
            locations: [],
        };
    }

    toggleScanning() {

        this.setState({isScanning: !this.state.isScanning});
    }

    toggleLoading() {

        this.setState({isLoading: !this.state.isLoading});
    }

    findValue(object, key, value) {

        return Object.values(object).find(v => v[key] === parseInt(value));
    }

    componentDidMount() {
        this.fetchFormats();
        this.props.fetchActiveRegister();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchFormats() {
        this._isMounted = true;
        http
            .request({url: API_HOST + API_ROOT + 'releases/formats'}, true)
            .then(response => {
                if (this._isMounted) {
                    this.setState({
                        formats: response.result.items.map(format => {
                            return {
                                value: format.id + '',
                                label: format.abbreviation || format.name,
                            };
                        }),
                    });
                }
            })
            .catch(error => {
                if (this._isMounted) {
                    console.error('Failed to fetch formats:', error);
                }
            });
    }
}

const mapStateToProps = (state) => ({
    products: state.inventory.products,
    activeRegister: state.register.activeRegister,
});

const mapDispatchToProps = {
    addProduct: addProduct,
    updateProductLocationAmount: updateProductLocationAmount,
    updateProductFormats: updateProductFormats,
    updateProduct: updateProduct,
    deleteProduct: deleteProduct,
    checkoutInventory: checkoutInventory,
    emptyInventory: emptyInventory,
    fetchActiveRegister: fetchActiveRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryModule);
